import { HttpClient } from '@angular/common/http';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { buildAuthConfig } from './services/auth.config';
import { AuthService } from './services/auth.service';
import { ConfigurationService } from './services/config.service';

//
// app init
//
export function ApplicationInitializer(
	configurationService: ConfigurationService,
	authService: AuthService,
): () => Promise<unknown> {
	const fnInit = async () => {
		await configurationService.init();
		const authConfig = buildAuthConfig(configurationService.configuration);
		await authService.initAuth(authConfig);
	};
	return (): Promise<unknown> => fnInit();
}

//
// i18n
//
export const createTranslateLoader = (http: HttpClient) => new TranslateHttpLoader(http, '/assets/i18n/', '.json');

export class MyMissingTranslationHandler implements MissingTranslationHandler {
	handle(params: MissingTranslationHandlerParams) {
		return `{ MISSING KEY : "${params.key}" }`;
	}
}

//
// misc
//
FullCalendarModule.registerPlugins([dayGridPlugin, timeGridPlugin, interactionPlugin]);
